"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tabs_1 = require("../../components/Tabs");
Tabs_1.Tabs.each('.tabs');
